module.exports = __webpack_public_path__ + "img/position_WF.5d2e52ca.png";